import React, { useState, useEffect } from 'react'

export const QuizButtons = ({ flipCard, nextCard }) => {
  const [isMd, setIsMd] = useState(false)

  useEffect(() => {
    const handleResize = () => setIsMd(window.innerWidth < 768)

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  })

  return (
    <div className="text-center my-3">
      <div
        className={`d-flex ${
          isMd ? 'flex-column' : 'justify-content-center flex-wrap'
        }`}
      >
        <button
          className={`btn btn-myed btn-primary btn-primary-myed btn-large-myed ${
            isMd ? 'd-block mb-2' : 'mr-3'
          }`}
          onClick={flipCard}
        >
          Flip Card
        </button>
        <button
          className={`btn btn-myed btn-primary btn-primary-myed btn-large-myed ${
            isMd ? 'd-block' : ''
          }`}
          onClick={nextCard}
        >
          Next Card
        </button>
      </div>
    </div>
  )
}
